var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tui-loading",style:({
    width: _vm.width,
    height: _vm.height,
    border: `2px solid ${_vm.color}`,
    borderTopColor: 'transparent',
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }